<template>
  <div class="userManagement-container">
    <div class="use_box">
      <el-form ref="form" :inline="true" :model="queryForm" @submit.native.prevent>
        <el-form-item label="任务码">
          <el-input
            ref="containerCode"
            v-model.trim="queryForm.containerCode"
            clearable
            placeholder="请扫描任务码"
            class="inputCss"
            @keyup.enter.native="containerCodeClick"
          />
        </el-form-item>
      </el-form>
      <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
      <!-- 分货弹窗 -->
      <sortGoods ref="sortGoods" @fetch-data="fetchData" />
    </div>
  </div>
</template>

<script>
import { order_box_improve_list } from '@/api/xgcApi'
import sortGoods from '../components/sortGoods.vue'
export default {
  components: {
    sortGoods
  },
  data() {
    return {
      queryForm: {
        containerCode: ''
      },
      code: ''
      
    }
  },
  created() {
    const code = localStorage.getItem('box_code')
    this.code = code
  },
  mounted() {
    if (this.code) {
      this.$refs['sortGoods'].showEdit(this.code)
    } else {
      this.containerCodeRefs()
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOutID)
  },
  methods: {
    // 容器码初始焦点
    containerCodeRefs() {
      const input = this.$refs.containerCode
      input.focus()
    },
    // 扫描任务码
    containerCodeClick() {
      if (this.queryForm.containerCode == '') {
        this.$message({
          message: '请扫描任务码',
          type: 'warning'
        })
      } else {
        order_box_improve_list({task_code:this.queryForm.containerCode})
          .then((res) => {
            this.goPicking()

          })
          .catch(() => {
            this.playAudio()
            this.queryForm.containerCode = ''
          })
      }
    },
    // 播放失败音效
    playAudio() {
      this.$refs.audioPlayer.play()
    },
    // 去分货
    goPicking() {
      this.$refs['sortGoods'].showEdit(this.queryForm.containerCode)
      this.queryForm.containerCode = ''
    },
    // 组件回显处理
    async fetchData() {
      this.queryForm.containerCode = ''
      this.$nextTick(() => {
        const input = this.$refs.containerCode
        input.focus()
      })

    }
  }
}

</script>
<style scoped>
.use_box {
  width: 100%;
  height: 90vh;
  background-color: #fff;
  padding: 15px;
  padding-top: 250px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
::v-deep .el-input--small .el-input__inner{
   height: 100px;
}
::v-deep .el-form-item--small .el-form-item__label{
  line-height: 100px;
  font-size: 50px;
}
.inputCss {
  width: 50vw;
  height: 100px !important;
  font-size: 50px;
}
::v-deep .el-input--medium .el-input__inner {
  height: 100px;
  line-height: 100px;
}
::v-deep .el-form-item--medium .el-form-item__label {
  line-height: 100px;
  font-size: 50px;
}
</style>
